// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 195) return "static/chunks/0224ceb2-21622b2c272843b5.js";
	if (chunkId === 584) return "static/chunks/584-0ed54d6c464dc0df.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"c6969882945e2117","777":"732f70bddc4f0b30","797":"e34e1fc974528e68"}[chunkId] + ".js";
};